var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"wzc_option",class:_vm.sizeSliderCurrent==_vm.label?'wzc_option_select':'',style:(_vm.styleVar),on:{"click":_vm.currentSelect}},[_c('div',{staticClass:"wzc_option_dropdown_item"},[_vm._v(_vm._s((_vm.precision && _vm.label%1 == 0) ? _vm.label + ".0" : _vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }